module.exports = __webpack_public_path__ + "static/media/calendar.020bc755.svg";